export const images = [
  { src: "./img/8.JPG", alt: "Image 7" },
  { src: "./img/10.jpg", alt: "Image 9" },
  { src: "./img/4.jpg", alt: "Image 3" },
  { src: "./img/11.JPG", alt: "Image 10" },
  { src: "./img/3.jpeg", alt: "Image 2" },
  { src: "./img/3.jpg", alt: "Image 3" },
  { src: "./img/5.jpg", alt: "Image 4" },
  { src: "./img/16.JPG", alt: "Image 15" },
  { src: "./img/6.jpeg", alt: "Image 5" },
  { src: "./img/9.jpg", alt: "Image 8" },
  { src: "./img/12.jpg", alt: "Image 11" },
  { src: "./img/13.jpg", alt: "Image 12" },
  { src: "./img/14.jpg", alt: "Image 13" },
  { src: "./img/15.jpg", alt: "Image 14" },

];

export const founderImages = [
  { src: "./img/founder1.png", alt: "Pradeepto 1" },
  { src: "./img/founder2.png", alt: "Pradeepto 2" }
];

export const Galleryimages = [
  { src: "./img/1.jfif", alt: "Image 1" },
  { src: "./img/4.jpg", alt: "Image 2" },
  { src: "./img/6.jpeg", alt: "Image 3" },
  { src: "./img/3.jpeg", alt: "Image 4" },
  { src: "./img/2.jpg", alt: "Image 5" },
  { src: "./img/5.jpg", alt: "Image 6" },
];

export const hackhazardsImages = [
  { src: "./img/hackhazards-images/img4.jpg", alt: "Image 4" },
  { src: "./img/hackhazards-images/img1.jpg", alt: "Image 1" },
  { src: "./img/hackhazards-images/img6.jpg", alt: "Image 6" },
  { src: "./img/hackhazards-images/img3.jpg", alt: "Image 3" },
  { src: "./img/hackhazards-images/img5.jpg", alt: "Image 5" },
  { src: "./img/hackhazards-images/img2.jpg", alt: "Image 2" },

]



export const testimonials = [
  {
    text: "It is great to be a part of such a great society. Here I got to work with many different individuals and learnt a lot of new skills both technical and non-technical such as how to manage a huge event like GeekTalk and knowing how much management and planning really goes into when organizing a event. The best society I have ever been a part of.",
    name: "Prasuk Jain",
    image:
      "https://user-images.githubusercontent.com/75252077/236657135-1edb8cab-c347-4be5-ae9c-506555c699eb.jpeg",
    position: "Organization Head 2022-23",
  },
  {
    text: "Nscc for me is a society which I could never dream of ...   First of all, when I enter society, it welcomes me with open arms... I was able to come in contact with like-minded tech geeks... Every member of society is so friendly, especially seniors.. They are helping  me in every doubt I have, either academic or personal. Society organises coding challenges every week to enhance our grasp on coding concepts. And the event organised by nscc is something else like interaction with geeks for geeks founder and techXlerate coding competition. They are just amazing. I am glad I chose nscc to be my first tech guidance adviser and hope to gain many more things in future  from them.",
    name: "Piyush Gupta",
    image: "https://i.postimg.cc/9F3byfGk/pi2.jpg",

    position: "Tech Team and Marketing Team",
  },
  {
    text: "The NSCC College Tech Society has been a game-changer for me. From the moment I joined, I was surrounded by a community of passionate and driven individuals who share my love for technology. The society has provided me with invaluable networking opportunities, skill-building workshops, and a supportive environment to explore and grow in my field. Being part of this society has not only expanded my knowledge but also connected me with like-minded peers and opened doors to exciting opportunities. I am grateful for the College Tech Society and the incredible impact it has had on my college experience.",
    name: "Nikhil Kumar",
    image:
      "https://github-production-user-asset-6210df.s3.amazonaws.com/50446690/241532037-e77697e9-77e6-48be-b432-2d2cb1188133.jpg",
    position: "Tech Team and Social Media Team",
  },
  {
    text: "As a senior tech team member at NSCC BPIT designing and developing our website was a rewarding experience, and the positive feedback received from users was overwhelming. Additionally, conducting a web development session for the society's members allowed me to share my expertise and witness their newfound knowledge and enthusiasm. The society's commitment to innovation and the supportive environment fostered personal and professional growth. I highly recommend NSCC BPIT as a platform for aspiring tech enthusiasts to excel and connect with like-minded individuals.",
    name: "Manan Khandelwal",
    image: "https://i.postimg.cc/50g3J5HQ/me.jpg",
    position: "Senior Tech Team 2022-23",
  },
  {
    text: "To be honest, joining NSCC BPIT has been a life changing moment for me. All the Seniors and Heads in the Community are extremely Supportive and Generous. All the Skills that I possess today are because of the Mentorship, Guidance, and Help provided to me by the seniors. All the members are really kind and supportive to help each other, making it a really inclusive community. Thank you NSCC BPIT for each and every thing.",
    name: "Shivank Kapur",
    image:
      "https://github-production-user-asset-6210df.s3.amazonaws.com/50446690/241532133-d2ad0f3e-88a0-4034-aeaa-86cceacc6d0c.jpg",
    position: "Tech Team and Outreach Team",
  },
  {
    text: "Newton School Coding Club has been a transformative experience for me at BPIT. The club's impact goes beyond being just a tech club. It has provided a positive and enriching environment where I've met incredible individuals who have shaped my college journey. I appreciate how NSCC at BPIT focuses on not only technical skills but also emphasizes the development of soft skills and personal growth. From engaging weekly sessions to the invaluable guidance of seniors, this club has been instrumental in driving my personal and professional growth.I highly recommend nscc to anyone passionate about technology and seeking a vibrant community to thrive in!",
    name: "Vaibhav Bhardwaj",
    image:
      "https://user-images.githubusercontent.com/75252077/236659081-d0dff70f-522d-4bad-bb67-2ab050ec8802.jpg",
    position: "Junior Council 2022-23",
  },
  {
    text: "I consider Newton School coding club to be more than just a tech club; it's like a second family to me. I've met amazing people who have influenced my college career in this uplifting and enriching environment. I like how the NSCC  spotlights both the development of soft skills and personal development in addition to technical skills. To anyone who is passionate about technology and looking for a healthy community, I wholeheartedly suggest the NSCC!",
    name: "Rupal Rastogi",
    image: "https://i.postimg.cc/CMqmQ877/Rupal.jpg",
    position: "Tech Team and Logistics Team",
  },
  {
    text: "I am writing this testimonial to express my heartfelt appreciation and respect for the incredible work carried out by NSCC BPIT in our college. As a student actively involved in the tech community, I have had the privilege of witnessing firsthand the exceptional initiatives, events, and opportunities created by this society. Really glad to be here and want to be a part in the future too.",
    name: "Daksh Sardana",
    image:
      "https://static.republika.co.id/uploads/member/images/news/bor6mn3jnr.jpg",
    position: "Tech Team and Graphics Team",
  },
  {
    text: "I am writing to express my sincere gratitude for the cherishing experience I had as a part of the Junior Council at NSCC. I am confident that the skills and knowledge I gained during my time on the council will help me to achieve my goals in the tech industry I am particularly grateful to my seniors at Nscc, who were constant support in my journey, and the peer group I got, which helped me in my learning journey. I also found the sessions conducted by NSCC to be very useful. These sessions covered a wide range of topics, including blockchain and other in- demand technologies, scholarships, and interview skills. I found the information in these sessions to be very helpful.  Thus I can say that Nscc will be one of the most memorable parts of my college life.",
    name: "Anushka Singh",
    image: "https://i.postimg.cc/ZRMn0Z9g/Anushka-Singh.jpg",
    position: "Junior Council 2022-23",
  },
  {
    text: "Being part of the content team of NSCC helped me flourish. Society’s fidelity for technical support and development helped students choose a new field in the technical domain. Seniors shared their expertise and helped the students explore the new domain in the computer science field, society helps me by guiding me in every way possible. Not only in the technical domain but also in the field of creativity, NSCC BPIT has always encouraged everyone in overall growth and development.",
    name: "Smriddhi Lau",
    image:
      "https://github-production-user-asset-6210df.s3.amazonaws.com/50446690/241535176-9b9f912f-1bd8-4d77-9606-2e99e6511af3.jpg",
    position: "Tech Team and Content Team",
  },
];

//members 1 is front page carousel 1
export const members1 = [

  {
    name: "Pranav Barthwal",
    image:
      "https://res.cloudinary.com/df5hitkbj/image/upload/v1699865734/PranavBarthwal_1_ycli1h.jpg",
    position: "President",
    github: "https://github.com/PranavBarthwal",
    linkedin: "https://www.linkedin.com/in/pranav-barthwal-b1a3631ba",
    instagram: "https://instagram.com/pranavbarthwal_",
  },

  {
    name: "Diksha Sharma",
    image:
      "https://res.cloudinary.com/dbffy7v9s/image/upload/v1721230258/xcu3r48yugyf0zht68fx.jpg",

    position: "President",
    github: "https://github.com/DikshaDhasmana",
    linkedin: "https://www.linkedin.com/in/diksha-sharma-1650b1258",
    instagram: "",
  },

  {
    name: "Jyoti Ahuja",
    image: "https://i.postimg.cc/L5mdsV6t/IMG-20230507-WA0029.jpg",
    position: "Marketing & Public Relations Head",
    linkedin: "https://www.linkedin.com/in/jyoti-ahuja-331228248",
    instagram: "https://www.instagram.com/_jyoti040",
  },

  {
    name: "Prerna Jha",
    image: "https://i.postimg.cc/RVRtqCGK/pi2.jpg",
    position: "Social Media & Content Head",
    linkedin: "https://www.linkedin.com/in/prerna-jha-6080a9253",
    instagram: "https://www.instagram.com/_prerna.____",
    twitter: "https://twitter.com/PrernaJha04"
  },

  {
    name: "Aryan Pillai",
    image:
      "https://res.cloudinary.com/df5hitkbj/image/upload/v1693238093/aryan_cwtlgr.jpg",
    position: "Design & Graphics Head",
    github: "https://github.com/aryanpillai103",
    linkedin: "https://www.linkedin.com/in/aryanpillai/",
    instagram: "https://www.instagram.com/a.pillai_19",
    twitter: "https://twitter.com/a_pillai103",
  },


  {
    name: "Sahil Tyagi",
    image:
      "https://res.cloudinary.com/df5hitkbj/image/upload/v1699865734/Sahil_Tyagi_1_pe2crg.jpg",
    position: "Logistics & Management Head",
    github: "https://github.com/SahilTyagii",
    linkedin: "https://www.linkedin.com/in/sahil-tyagi-b4a02325a/",
    instagram: "https://www.instagram.com/sahil.tyagii/",
  },

  {
    name: "Sujal Gupta",
    image:
      "https://i.ibb.co/FxGpRGS/Whats-App-Image-2022-07-13-at-8-55-19-PM.jpg",
    position: "Web Dev Head",
    github: "https://github.com/sgmna",
    linkedin: "https://www.linkedin.com/in/sujal-gupta-117154247/",
    instagram: "https://www.instagram.com/sujalgupta1214",
  },

  {
    name: "Mokshit Garg",
    image:
      "https://res.cloudinary.com/df5hitkbj/image/upload/v1693237985/mokshit_mf8xx7.jpg",
    position: "App Dev Head",
    github: "https://github.com/Mokshit-123",
    linkedin: "https://www.linkedin.com/in/mokshit-garg-283b27247",
    instagram: "https://www.instagram.com/mokshu_123",
    twitter:
      "https://twitter.com/Mokshit0068",
  },

  {
    name: "Shivank Kapur",
    image:
      "https://res.cloudinary.com/df5hitkbj/image/upload/v1693238094/shivank_hglloc.jpg",
    position: "Blockchain Head",
    github: "https://github.com/ShivankK26",
    linkedin: "https://www.linkedin.com/in/shivankkapur",
    instagram: "https://www.instagram.com/Kapur.shivank2",
    twitter: "https://twitter.com/ShivankK26",
  },

  {
    name: "Yuvan Grover",
    image:
      "https://res.cloudinary.com/df5hitkbj/image/upload/v1699865734/Yuvan_pic_2_1_wtwurh.jpg",
    position: "DSA Head",
    github: "https://github.com/coderyuvan",
    linkedin: "https://www.linkedin.com/in/yuvan-grover-85b03526a",
    instagram: "",
  },
  {
    name: "Garv Khurana",
    image:
      "https://res.cloudinary.com/dyfhx6mqp/image/upload/v1720981315/Garv_khurana_dqljz2.jpg",
    position: "AI and ML Head",
    github: "https://github.com/garvkhurana",
    linkedin: "https://www.linkedin.com/in/garv-khurana-07a8a92a4/",
    instagram: "",
  },


  {
    name: "Jatin Gera",
    image:
      "https://res.cloudinary.com/dyfhx6mqp/image/upload/v1720981301/Jatin_Gera.JPG_cxptou.jpg",
    position: "Cloud & DevOps Head",
    github: "https://github.com/JatinGera27aug",
    linkedin: "https://www.linkedin.com/in/jatin-gera-27aug",
    instagram: "https://www.instagram.com/jatingera2004?igsh=Z2phNHRtMWJwM3lj",
  },
  {
    name: "Ankur Sharma",
    image:
      "https://res.cloudinary.com/dyfhx6mqp/image/upload/v1720981326/IMG20240120170745_h2s0ev.jpg",
    position: "Cybersecurity Head",
    github: "https://github.com/ankursagar020",
    linkedin: "https://www.linkedin.com/in/ankur-sharma-674526268?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    instagram: ""
  },
  {
    name: "Prabal Aggarwal",
    image:
      "",
    position: "UI and UX Head",
    github: "",
    linkedin: "",
    instagram: "",
  },
  {
    name: "Shreya Jaiswal",
    image: "https://res.cloudinary.com/dyfhx6mqp/image/upload/v1720980759/WhatsApp_Image_2024-07-14_at_11.33.01_PM_qlbl3b.jpg",
    position: "Junior Council",
    github: "https://github.com/shreyajaiswal17",
    linkedin: "http://www.linkedin.com/in/shreya-jaiswal17",
    instagram: "",
  },
  {
    name: "Romanch Roshan Singh ",
    image: "https://res.cloudinary.com/dyfhx6mqp/image/upload/v1720980996/Romanch_sjujtx.jpg",
    position: "Junior Council",
    github: "https://github.com/codedpool",
    linkedin: "https://in.linkedin.com/in/romanch-roshan-singh-bb746b296",
    instagram: "",
  },
  {
    name: "Lavanya Varshney",
    image: "https://res.cloudinary.com/dyfhx6mqp/image/upload/v1720981024/Lavanya_Varshney_cqtqkd.jpg",
    position: "Junior Council",
    github: "https://github.com/Lavavarshney",
    linkedin: "https://www.linkedin.com/in/lavanya-varshney-294440284?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    instagram: "",
  },

  {
    name: "Vansh Garg",
    image: "https://res.cloudinary.com/dyfhx6mqp/image/upload/v1720980985/Vansh_Garg_aqqpmv.jpg",
    position: "Junior Council",
    github: "https://github.com/VANSHG2005",
    linkedin: "https://www.linkedin.com/in/vansh-garg-336241297/",
    instagram: "https://www.instagram.com/vanshgarg_2005/",
  },

  {
    name: "Arush Karnatak",
    image: "https://res.cloudinary.com/dyfhx6mqp/image/upload/v1728229848/IMG_20240408_175646_efb1c2.jpg",
    position: "Junior Council",
    github: "http://github.com/karush2807",
    linkedin: "https://www.linkedin.com/in/arush-karnatak-894bb52a1/",
    instagram: "",
  },

  {
    name: "Krish Mishra",
    image: "https://res.cloudinary.com/dyfhx6mqp/image/upload/v1720981028/Krish_Mishra_pcmpgq.jpg",
    position: "Junior Council",
    github: "https://github.com/krysh420",
    linkedin: "https://www.linkedin.com/in/krish-mishra-a9410917b?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    instagram: "https://www.instagram.com/krysh.420?igsh=MWx0ZXNiNXV5OHB4Zw==",
  },

  {
    name: "Nibedan Pati",
    image: "https://res.cloudinary.com/dyfhx6mqp/image/upload/v1720981006/Nibedan_Pati_lbau4p.jpg",
    position: "Junior Council",
    github: "https://github.com/Heisenberg300604",
    linkedin: "https://www.linkedin.com/in/nibedan-pati-2139b3277/",
    instagram: "https://www.instagram.com/nibedan_3006/",
  },
  {
    name: "Vrinda Bindal",
    image: "https://res.cloudinary.com/dyfhx6mqp/image/upload/v1720980926/Vrinda_Bindal_pwvtiv.jpg",
    position: "Junior Council",
    github: "https://github.com/vrindabindal12",
    linkedin: "",
    instagram: "",
  },
  {
    name: "Arsh Tiwari",
    image: "https://res.cloudinary.com/dyfhx6mqp/image/upload/v1720981064/Arsh_Tiwari_oocqph.jpg",
    position: "Junior Council",
    github: "https://github.com/ArshTiwari2004",
    linkedin: "https://leetcode.com/u/ArshTiwari/",
    instagram: "https://www.instagram.com/_.arshtiwari/",
  },
  {
    name: "Krish Gupta",
    image: "https://res.cloudinary.com/dyfhx6mqp/image/upload/v1736010637/new_edited_-_Krish_Gupta_u7xxp0.png",
    position: "Junior Council",
    github: "https://github.com/KrishGuptaXO	",
    linkedin: "https://www.linkedin.com/in/krish-gupta-b2b3b7287",
    instagram: "https://www.instagram.com/illusioner.kg_02	",
  },
  {
    name: "Raghav Bansal",
    image: "https://res.cloudinary.com/dyfhx6mqp/image/upload/v1736010655/Screenshot_2024-10-05_151038-photoaidcom-cropped_-_Raghav_bansal_femaju.png",
    position: "Junior Council",
    github: "https://github.com/RaghavBansal-2006	",
    linkedin: "https://www.linkedin.com/in/raghavbansal2006/	",
    instagram: "https://www.instagram.com/raghavbansal__18/		",
  },
  {
    name: "	Jatin Chhabra",
    image: "https://res.cloudinary.com/dyfhx6mqp/image/upload/v1736010667/image_1_-_Jatin_Chhabra_lssukr.jpg",
    position: "Junior Council",
    github: "https://github.com/Jatinchhabra22",
    linkedin: "https://www.linkedin.com/in/jatin-chhabra-2b0455289/		",
    instagram: "https://www.instagram.com/zateeeenn/",
  },
  {
    name: "	Ranjan",
    image: "https://res.cloudinary.com/dyfhx6mqp/image/upload/v1736010681/ranjan_pic_-_Ranjan_Kumar_azym8a.jpg",
    position: "Junior Council",
    github: "https://github.com/just4codingonly",
    linkedin: "https://www.linkedin.com/in/ranjan-kumar-586aa2278/		",
    instagram: "https://www.instagram.com/r4__ranjan/?next=%2F",
  },
  {
    name: "	Aditi Sharma",
    image: "https://res.cloudinary.com/dyfhx6mqp/image/upload/v1736010694/Screenshot_20241202-193708_2_-_Aditi_Sharma_tzk4m8.png",
    position: "Junior Council",
    github: "https://github.com/thtsunshine/",
    linkedin: "https://www.linkedin.com/in/aditi-sharma-399a44327/		",
    instagram: "",
  },
  {
    name: "	Shrishti Tomar",
    image: "https://res.cloudinary.com/dyfhx6mqp/image/upload/v1736010712/Snapchat-1678896509_-_Shrishti_Tomar_hgbrpq.jpg",
    position: "Junior Council",
    github: "",
    linkedin: "",
    instagram: "",
  },
];

//members2 is the 2nd carousel on home page
export const members2 = [
  {
    image:
      "https://res.cloudinary.com/df5hitkbj/image/upload/v1693141355/WhatsApp_Image_2023-08-27_at_18.31.44_bcdpq4.jpg",
    name: "Pradeepto Sarkar",
    position: "Founder and Advisor",
    team: "SC",
    github: "https://github.com/pradeeptosarkar",
    linkedin: "https://www.linkedin.com/in/pradeeptosarkar",
    instagram: "https://instagram.com/pradeeptosarkar",
    twitter: "https://twitter.com/pradeepto_src",
  },

  {
    image:
      "https://user-images.githubusercontent.com/75252077/236657010-53641de3-591f-4a61-87c6-c94d2209d52f.jpg",
    name: "Kartik Sharma",
    position: "Co-Founder",
    team: "SC",
    github: "https://github.com/krtk-097",
    linkedin: "https://www.linkedin.com/in/kartiksharma01/",
    instagram: "https://www.instagram.com/krtk_097/",
    twitter: "https://twitter.com/Krma_097",
  },

  {
    image:
      "https://user-images.githubusercontent.com/75252077/236657113-d0c60da5-7df8-442f-940f-72454982f671.jpg",
    name: "Isha Bansal",
    position: "Co-Founder",
    team: "SC",
    github: "",
    linkedin: "https://www.linkedin.com/in/isha-bansal-439a51215",
    instagram: "https://instagram.com/isha82302?igshid=ZDdkNTZiNTM=",
    twitter: "",
  },

  {
    image:
      "https://user-images.githubusercontent.com/75252077/236657135-1edb8cab-c347-4be5-ae9c-506555c699eb.jpeg",
    name: "Prasuk Jain",
    position: "Co-Founder",
    team: "SC",
    github: "https://github.com/JPrasuk31",
    linkedin: "https://www.linkedin.com/in/prasuk-jain-52bb55203/",
    instagram: "https://www.instagram.com/j_.prasuk/",
    twitter: "",
  },

  {
    image:
      "https://user-images.githubusercontent.com/75252077/236657164-56f95fb6-2a4b-49de-901b-fdfe4d1b5b97.jpg",
    name: "Deepika",
    position: "Co-Founder",
    team: "SC",
    github: "https://github.com/deepika-sys",
    linkedin: "https://www.linkedin.com/in/deepika-583a1b209",
    instagram: "vatsdeepika19",
    twitter: "https://www.instagram.com/Deepika01907",
  },

  {
    image:
      "https://github-production-user-asset-6210df.s3.amazonaws.com/50446690/241362588-f5980a33-1a02-482d-9c3c-d5bf1575bada.jpg",
    name: "Prishita Aggarwal",
    position: "Co-Founder",
    team: "SC",
    github: "",
    linkedin: "https://www.linkedin.com/in/prishita-aggarwal",
    instagram: "prishita02",
    twitter: "",
  },

  {
    image:
      "https://user-images.githubusercontent.com/75252077/236657406-e6b46519-5a51-4be0-ac68-1ead8f42b56c.jpg",
    name: "Vishesh Khare",
    position: "Co-Founder",
    team: "SC",
    github: "https://github.com/visheshkhare",
    linkedin: "https://www.linkedin.com/in/vishesh-khare-4a8869185",
    instagram: "https://instagram.com/vishesh._.khare?igshid=ZDdkNTZiNTM=",
    twitter: "https://twitter.com/visheshkhare5?t=25AEBGXjQmsCcbE1PuGlzg&s=09",
  },


  {
    name: "Lavanshi Bansal",
    image: "./img/Lavanshi.jpg",
    position: "Advisor",
    github: "https://github.com/lavanshi295",
    linkedin: "https://www.linkedin.com/in/lavanshi-bansal-52525722a",
    instagram: "https://www.instagram.com/its.girlygirl_",
    twitter: "https://twitter.com/LavanshiB?t=PJYiDx8vaxalebL9-Zb4qA&amp;s=09",
  },

  {
    image:
      "https://res.cloudinary.com/df5hitkbj/image/upload/v1701273886/Sneha_Nautiyal_qeuhfe.jpg",
    name: "Sneha Nautiyal",
    position: "Advisor",
    github: "https://github.com/Klynweto",
    linkedin: "https://www.linkedin.com/in/sneha-nautiyal-8b8a13242",
    instagram: "https://www.instagram.com/klynweto",
  },

  {
    image:
      "https://user-images.githubusercontent.com/75252077/236658653-d05fa062-283e-4520-9a71-4d01d7f2b4f4.jpg",
    name: "Rishav Raj",
    position: "Advisor",
    github: "https://github.com/Rishav-01",
    linkedin: "https://www.linkedin.com/in/rishav-raj-8128bb228/",
    instagram: "https://www.instagram.com/rishav_th9/",
    twitter: "",
  },

  {
    "name": "Gautam Gupta",
    "image": "https://res.cloudinary.com/df5hitkbj/image/upload/v1696347467/WhatsApp_Image_2023-10-03_at_19.48.38_9b68ab3a_pdkmkv.jpg",
    position: "Advisor",
    github: "https://github.com/Gautam1610",
    "linkedin": "https://www.linkedin.com//in//gautam-gupta-8a039022a",
    "instagram": "https://www.instagram.com//_gautam.gupta"
  },


  {
    "name": "Aakash Gupta",
    "image": "https://res.cloudinary.com/df5hitkbj/image/upload/v1696347467/WhatsApp_Image_2023-10-03_at_19.48.37_f778fcc2_m1gihp.jpg",
    position: "Advisor",
    github: "https://github.com/aakashgg",
    "linkedin": "https://www.linkedin.com//in//aakashgupta46",
    "instagram": "https://www.instagram.com//itss_aakash_"
  },

  {
    "name": "Akshit Shroff",
    "image": "https://res.cloudinary.com/df5hitkbj/image/upload/v1701314230/Akshit_Shroff_mgbxhf.jpg",
    position: "Advisor",
    github: "https://github.com/Akay-Code",
    "linkedin": "https://www.linkedin.com//in//akshit-shroff",
    "instagram": ""
  },

  {
    image:
      "https://user-images.githubusercontent.com/75252077/236658902-912d6d6c-6790-41ee-b65b-5ccd4e2eea40.jpeg",
    name: "Raj Verma",
    position: "Advisor",
    github: "https://github.com/raj18verma",
    linkedIn: "https://www.linkedin.com/in/raj-verma-a68356255/",
    instagram: "https://www.instagram.com/raj18verma/",
    twitter: "https://twitter.com/RajVerm51468503",
  },
];

export const allmembers = [
  {
    image:
      "https://res.cloudinary.com/df5hitkbj/image/upload/v1693141355/WhatsApp_Image_2023-08-27_at_18.31.44_bcdpq4.jpg",
    name: "Pradeepto Sarkar",
    position: "Founder and Advisor",
    team: "SC",
    github: "https://github.com/pradeeptosarkar",
    linkedin: "https://www.linkedin.com/in/pradeeptosarkar",
    instagram: "https://instagram.com/pradeeptosarkar",
    twitter: "https://twitter.com/pradeepto_src",
  },

  {
    image:
      "https://user-images.githubusercontent.com/75252077/236657010-53641de3-591f-4a61-87c6-c94d2209d52f.jpg",
    name: "Kartik Sharma",
    position: "Co-Founder",
    team: "SC",
    github: "https://github.com/krtk-097",
    linkedin: "https://www.linkedin.com/in/kartiksharma01/",
    instagram: "https://www.instagram.com/krtk_097/",
    twitter: "https://twitter.com/Krma_097",
  },

  {
    image:
      "https://user-images.githubusercontent.com/75252077/236657113-d0c60da5-7df8-442f-940f-72454982f671.jpg",
    name: "Isha Bansal",
    position: "Co-Founder",
    team: "SC",
    github: "",
    linkedin: "https://www.linkedin.com/in/isha-bansal-439a51215",
    instagram: "https://instagram.com/isha82302?igshid=ZDdkNTZiNTM=",
    twitter: "",
  },

  {
    image:
      "https://user-images.githubusercontent.com/75252077/236657135-1edb8cab-c347-4be5-ae9c-506555c699eb.jpeg",
    name: "Prasuk Jain",
    position: "Co-Founder",
    team: "SC",
    github: "https://github.com/JPrasuk31",
    linkedin: "https://www.linkedin.com/in/prasuk-jain-52bb55203/",
    instagram: "https://www.instagram.com/j_.prasuk/",
    twitter: "",
  },

  {
    image:
      "https://user-images.githubusercontent.com/75252077/236657164-56f95fb6-2a4b-49de-901b-fdfe4d1b5b97.jpg",
    name: "Deepika",
    position: "Co-Founder",
    team: "SC",
    github: "https://github.com/deepika-sys",
    linkedin: "https://www.linkedin.com/in/deepika-583a1b209",
    instagram: "vatsdeepika19",
    twitter: "https://www.instagram.com/Deepika01907",
  },

  {
    image:
      "https://github-production-user-asset-6210df.s3.amazonaws.com/50446690/241362588-f5980a33-1a02-482d-9c3c-d5bf1575bada.jpg",
    name: "Prishita Aggarwal",
    position: "Co-Founder",
    team: "SC",
    github: "",
    linkedin: "https://www.linkedin.com/in/prishita-aggarwal",
    instagram: "prishita02",
    twitter: "",
  },

  {
    image:
      "https://user-images.githubusercontent.com/75252077/236657406-e6b46519-5a51-4be0-ac68-1ead8f42b56c.jpg",
    name: "Vishesh Khare",
    position: "Co-Founder",
    team: "SC",
    github: "https://github.com/visheshkhare",
    linkedin: "https://www.linkedin.com/in/vishesh-khare-4a8869185",
    instagram: "https://instagram.com/vishesh._.khare?igshid=ZDdkNTZiNTM=",
    twitter: "https://twitter.com/visheshkhare5?t=25AEBGXjQmsCcbE1PuGlzg&s=09",
  },


  {
    name: "Lavanshi Bansal",
    image: "./img/Lavanshi.jpg",
    position: "Advisor",
    github: "https://github.com/lavanshi295",
    linkedin: "https://www.linkedin.com/in/lavanshi-bansal-52525722a",
    instagram: "https://www.instagram.com/its.girlygirl_",
    twitter: "https://twitter.com/LavanshiB?t=PJYiDx8vaxalebL9-Zb4qA&amp;s=09",
  },

  {
    image:
      "https://res.cloudinary.com/df5hitkbj/image/upload/v1701273886/Sneha_Nautiyal_qeuhfe.jpg",
    name: "Sneha Nautiyal",
    position: "Advisor",
    github: "https://github.com/Klynweto",
    linkedin: "https://www.linkedin.com/in/sneha-nautiyal-8b8a13242",
    instagram: "https://www.instagram.com/klynweto",
  },

  {
    image:
      "https://user-images.githubusercontent.com/75252077/236658653-d05fa062-283e-4520-9a71-4d01d7f2b4f4.jpg",
    name: "Rishav Raj",
    position: "Advisor",
    github: "https://github.com/Rishav-01",
    linkedin: "https://www.linkedin.com/in/rishav-raj-8128bb228/",
    instagram: "https://www.instagram.com/rishav_th9/",
    twitter: "",
  },

  {
    "name": "Gautam Gupta",
    "image": "https://res.cloudinary.com/df5hitkbj/image/upload/v1696347467/WhatsApp_Image_2023-10-03_at_19.48.38_9b68ab3a_pdkmkv.jpg",
    position: "Advisor",
    github: "https://github.com/Gautam1610",
    "linkedin": "https://www.linkedin.com//in//gautam-gupta-8a039022a",
    "instagram": "https://www.instagram.com//_gautam.gupta"
  },


  {
    "name": "Aakash Gupta",
    "image": "https://res.cloudinary.com/df5hitkbj/image/upload/v1696347467/WhatsApp_Image_2023-10-03_at_19.48.37_f778fcc2_m1gihp.jpg",
    position: "Advisor",
    github: "https://github.com/aakashgg",
    "linkedin": "https://www.linkedin.com//in//aakashgupta46",
    "instagram": "https://www.instagram.com//itss_aakash_"
  },

  {
    "name": "Akshit Shroff",
    "image": "https://res.cloudinary.com/df5hitkbj/image/upload/v1701314230/Akshit_Shroff_mgbxhf.jpg",
    position: "Advisor",
    github: "https://github.com/Akay-Code",
    "linkedin": "https://www.linkedin.com//in//akshit-shroff",
    "instagram": ""
  },

  {
    image:
      "https://user-images.githubusercontent.com/75252077/236658902-912d6d6c-6790-41ee-b65b-5ccd4e2eea40.jpeg",
    name: "Raj Verma",
    position: "Advisor",
    github: "https://github.com/raj18verma",
    linkedIn: "https://www.linkedin.com/in/raj-verma-a68356255/",
    instagram: "https://www.instagram.com/raj18verma/",
    twitter: "https://twitter.com/RajVerm51468503",
  },

  {
    name: "Diksha Sharma",
    image:
      "https://res.cloudinary.com/dbffy7v9s/image/upload/v1721230258/xcu3r48yugyf0zht68fx.jpg",
    position: "President",
    github: "https://github.com/DikshaDhasmana",
    linkedin: "https://www.linkedin.com/in/diksha-sharma-1650b1258",
    instagram: "",
  },

  {
    name: "Pranav Barthwal",
    image:
      "https://res.cloudinary.com/df5hitkbj/image/upload/v1699865734/PranavBarthwal_1_ycli1h.jpg",
    position: "President",
    github: "https://github.com/PranavBarthwal",
    linkedin: "https://www.linkedin.com/in/pranav-barthwal-b1a3631ba",
    instagram: "https://instagram.com/pranavbarthwal_",
    twitter: "https://twitter.com/pranavbarthwal_",
  },

  {
    name: "Aryan Pillai",
    image:
      "https://res.cloudinary.com/df5hitkbj/image/upload/v1693238093/aryan_cwtlgr.jpg",
    position: "Graphics Head",
    github: "https://github.com/aryanpillai103",
    linkedin: "https://www.linkedin.com/in/aryanpillai/",
    instagram: "https://www.instagram.com/a.pillai_19",
    twitter: "https://twitter.com/a_pillai103",
  },

  {
    name: "Jyoti Ahuja",
    image: "https://i.postimg.cc/L5mdsV6t/IMG-20230507-WA0029.jpg",
    position: "Marketing Head",
    linkedin: "https://www.linkedin.com/in/jyoti-ahuja-331228248",
    instagram: "https://www.instagram.com/_jyoti040",
  },
  {
    name: "Prerna Jha",
    image: "https://i.postimg.cc/RVRtqCGK/pi2.jpg",
    position: "Social Media and Content Head",
    linkedin: "https://www.linkedin.com/in/prerna-jha-6080a9253",
    instagram: "https://www.instagram.com/_prerna.____",
    twitter: "https://twitter.com/PrernaJha04"
  },

  {
    name: "Sahil Tyagi",
    image:
      "https://res.cloudinary.com/df5hitkbj/image/upload/v1699865734/Sahil_Tyagi_1_pe2crg.jpg",
    position: "Logistics Head",
    github: "https://github.com/SahilTyagii",
    linkedin: "https://www.linkedin.com/in/sahil-tyagi-b4a02325a/",
    instagram: "https://www.instagram.com/sahil.tyagii/",
  },
  {
    name: "Mokshit Garg",
    image:
      "https://res.cloudinary.com/df5hitkbj/image/upload/v1693237985/mokshit_mf8xx7.jpg",
    position: "App Development Head",
    github: "https://github.com/Mokshit-123",
    linkedin: "https://www.linkedin.com/in/mokshit-garg-283b27247",
    instagram: "https://www.instagram.com/mokshu_123",
    twitter:
      "https://twitter.com/Mokshit0068",
  },
  {
    name: "Shivank Kapur",
    image:
      "https://res.cloudinary.com/df5hitkbj/image/upload/v1693238094/shivank_hglloc.jpg",
    position: "Blockchain Head",
    github: "https://github.com/ShivankK26",
    linkedin: "https://www.linkedin.com/in/shivankkapur",
    instagram: "https://www.instagram.com/Kapur.shivank2",
    twitter: "https://twitter.com/ShivankK26",
  },

  {
    name: "Sujal Gupta",
    image:
      "https://i.ibb.co/FxGpRGS/Whats-App-Image-2022-07-13-at-8-55-19-PM.jpg",
    position: "Web Development Head",
    github: "https://github.com/sgmna",
    linkedin: "https://www.linkedin.com/in/sujal-gupta-117154247/",
    instagram: "https://www.instagram.com/sujalgupta1214",
  },

  {
    name: "Yuvan Grover",
    image:
      "https://res.cloudinary.com/df5hitkbj/image/upload/v1699865734/Yuvan_pic_2_1_wtwurh.jpg",
    position: "Data Structures and Algorithms Head",
    github: "https://github.com/coderyuvan",
    linkedin: "https://www.linkedin.com/in/yuvan-grover-85b03526a",
    instagram: "",
  },

  {
    name: "Jatin Gera",
    image:
      "https://res.cloudinary.com/dyfhx6mqp/image/upload/v1720981301/Jatin_Gera.JPG_cxptou.jpg",
    position: "Cloud and Devops Head",
    github: "https://github.com/JatinGera27aug",
    linkedin: "https://www.linkedin.com/in/jatin-gera-27aug",
    instagram: "https://www.instagram.com/jatingera2004?igsh=Z2phNHRtMWJwM3lj",
  },
  {
    name: "Ankur Sharma",
    image:
      "https://res.cloudinary.com/dyfhx6mqp/image/upload/v1720981326/IMG20240120170745_h2s0ev.jpg",
    position: "Cybersecurity Head",
    github: "https://github.com/ankursagar020",
    linkedin: "https://www.linkedin.com/in/ankur-sharma-674526268?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    instagram: ""
  },
  {
    name: "Prabal Aggarwal",
    image:
      "",
    position: "UI and UX Head",
    github: "",
    linkedin: "",
    instagram: "",
  },
  {
    name: "	Aditi Sharma",
    image: "https://res.cloudinary.com/dyfhx6mqp/image/upload/v1736010694/Screenshot_20241202-193708_2_-_Aditi_Sharma_tzk4m8.png",
    position: "Junior Council",
    github: "https://github.com/thtsunshine/",
    linkedin: "https://www.linkedin.com/in/aditi-sharma-399a44327/		",
    instagram: "",
  },
  {
    name: "Arsh Tiwari",
    image: "https://res.cloudinary.com/dyfhx6mqp/image/upload/v1720981064/Arsh_Tiwari_oocqph.jpg",
    position: "Junior Council",
    github: "https://github.com/ArshTiwari2004",
    linkedin: "https://www.linkedin.com/in/arsh-tiwari-072609284/",
    instagram: "https://www.instagram.com/_.arshtiwari/"
  },
  {

    name: "Arush Karnatak",
    image: "https://res.cloudinary.com/dyfhx6mqp/image/upload/v1728229848/IMG_20240408_175646_efb1c2.jpg",
    position: "Junior Council",
    github: "http://github.com/karush2807",
    linkedin: "https://www.linkedin.com/in/arush-karnatak-894bb52a1/",
    instagram: "",

  },
  {
    name: "	Jatin Chhabra",
    image: "https://res.cloudinary.com/dyfhx6mqp/image/upload/v1736010667/image_1_-_Jatin_Chhabra_lssukr.jpg",
    position: "Junior Council",
    github: "https://github.com/Jatinchhabra22",
    linkedin: "https://www.linkedin.com/in/jatin-chhabra-2b0455289/		",
    instagram: "https://www.instagram.com/zateeeenn/",
  },
  {
    name: "Krish Gupta",
    image: "https://res.cloudinary.com/dyfhx6mqp/image/upload/v1736010637/new_edited_-_Krish_Gupta_u7xxp0.png",
    position: "Junior Council",
    github: "https://github.com/KrishGuptaXO	",
    linkedin: "https://www.linkedin.com/in/krish-gupta-b2b3b7287",
    instagram: "https://www.instagram.com/illusioner.kg_02	",
  },
 
  {
    name: "Krish Mishra",
    image: "https://res.cloudinary.com/dyfhx6mqp/image/upload/v1720981028/Krish_Mishra_pcmpgq.jpg",
    position: "Junior Council",
    github: "https://github.com/krysh420",
    linkedin: "https://www.linkedin.com/in/krish-mishra-a9410917b?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    instagram: "https://www.instagram.com/krysh.420?igsh=MWx0ZXNiNXV5OHB4Zw=="
  },
  {
    name: "Lavanya Varshney",
    image: "https://res.cloudinary.com/dyfhx6mqp/image/upload/v1720981024/Lavanya_Varshney_cqtqkd.jpg",
    position: "Junior Council",
    github: "https://github.com/Lavavarshney",
    linkedin: "https://www.linkedin.com/in/lavanya-varshney-294440284?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    instagram: "",
  },
  {
    name: "Nibedan Pati",
    image: "https://res.cloudinary.com/dyfhx6mqp/image/upload/v1720981006/Nibedan_Pati_lbau4p.jpg",
    position: "Junior Council",
    github: "https://github.com/Heisenberg300604",
    linkedin: "https://www.linkedin.com/in/nibedan-pati-2139b3277/",
    instagram: "https://www.instagram.com/nibedan_3006/",
  },
  {
    name: "Raghav Bansal",
    image: "https://res.cloudinary.com/dyfhx6mqp/image/upload/v1736010655/Screenshot_2024-10-05_151038-photoaidcom-cropped_-_Raghav_bansal_femaju.png",
    position: "Junior Council",
    github: "https://github.com/RaghavBansal-2006	",
    linkedin: "https://www.linkedin.com/in/raghavbansal2006/	",
    instagram: "https://www.instagram.com/raghavbansal__18/		",
  },
  {
    name: "	Ranjan",
    image: "https://res.cloudinary.com/dyfhx6mqp/image/upload/v1736010681/ranjan_pic_-_Ranjan_Kumar_azym8a.jpg",
    position: "Junior Council",
    github: "https://github.com/just4codingonly",
    linkedin: "https://www.linkedin.com/in/ranjan-kumar-586aa2278/		",
    instagram: "https://www.instagram.com/r4__ranjan/?next=%2F",
  },
  {
    name: "Romanch Roshan Singh ",
    image: "https://res.cloudinary.com/dyfhx6mqp/image/upload/v1720980996/Romanch_sjujtx.jpg",
    position: "Junior Council",
    github: "https://github.com/codedpool",
    linkedin: "https://in.linkedin.com/in/romanch-roshan-singh-bb746b296",
    instagram: "",
  },
  {
    name: "Shreya Jaiswal",
    image: "https://res.cloudinary.com/dyfhx6mqp/image/upload/v1720980759/WhatsApp_Image_2024-07-14_at_11.33.01_PM_qlbl3b.jpg",
    position: "Junior Council",
    github: "https://github.com/shreyajaiswal17",
    linkedin: "http://www.linkedin.com/in/shreya-jaiswal17",
    instagram: "https://www.instagram.com/shreya.j17/",
  },
  
  {
    name: "	Shrishti Tomar",
    image: "https://res.cloudinary.com/dyfhx6mqp/image/upload/v1736010712/Snapchat-1678896509_-_Shrishti_Tomar_hgbrpq.jpg",
    position: "Junior Council",
    github: "",
    linkedin: "",
    instagram: "",
  },
  {
    name: "Vang Garg",
    image: "https://res.cloudinary.com/dyfhx6mqp/image/upload/v1720980985/Vansh_Garg_aqqpmv.jpg",
    position: "Junior Council",
    github: "https://github.com/VANSHG2005",
    linkedin: "https://www.linkedin.com/in/vansh-garg-336241297/",
    instagram: "https://www.instagram.com/vanshgarg_2005/",
  },
  {
    name: "Vrinda Bindal",
    image: "https://res.cloudinary.com/dyfhx6mqp/image/upload/v1720980926/Vrinda_Bindal_pwvtiv.jpg",
    position: "Junior Council",
    github: "https://github.com/vrindabindal12",
    linkedin: "",
    instagram: "",
  },
  
  


  {
    image:
      "https://res.cloudinary.com/df5hitkbj/image/upload/v1693144357/WhatsApp_Image_2023-08-27_at_19.22.07_aar0ka.jpg",
    name: "Anushka Singh",
    position: "Ex-President",
    github: "https://github.com/anu30singh",
    linkedin: "https://www.linkedin.com/in/anushka30singh/",
    instagram: "https://instagram.com/anu_30singh?igshid=ZDdkNTZiNTM=",
    twitter: "https://twitter.com/Anushka3007",
  },

  {
    image:
      "https://user-images.githubusercontent.com/75252077/236658748-0dd5a22a-52eb-471c-8662-36efa310a38e.jpg",
    name: "Vaibhav Goyal",
    position: "Ex-Vice President",
    github: "https://github.com/vaiibhav75",
    linkedin: "https://www.linkedin.com/in/vaibhav-goyal-0a5b91235",
    instagram: "https://www.instagram.com/vaiibhav_goyal",
    twitter: "",
  },

  {
    image:
      "https://res.cloudinary.com/df5hitkbj/image/upload/v1693143855/WhatsApp_Image_2023-08-27_at_19.13.49_njoj6r.jpg",
    name: "Daxh Khatreja",
    position: "Ex-Vice President",
    github: "https://github.com/khatrejadaxh04",
    linkedIn: "https://linkedin.com/in/daxh-khatreja-885641227",
    instagram: "https://www.instagram.com/_khatrejadaxh4_/",
    twitter: "https://twitter.com/_khatrejadaxh4_",
  },

  {
    image:
      "https://res.cloudinary.com/df5hitkbj/image/upload/v1693141782/Tanish_uevbku.jpg",
    name: "Tanish Saini",
    position: "Ex-Senior Council",
    github: "https://github.com/TaniKroos",
    linkedIn: "https://www.linkedin.com/in/tanish-saini-90410822a/",
    instagram: "",
    twitter: "https://twitter.com/Tanish2731",
  },

  {
    image:
      "https://user-images.githubusercontent.com/75252077/236658980-c59934e8-c9db-4a9d-82a3-93ebb76c5156.jpg",
    name: "Ayush Jaswal",
    position: "Ex-Senior Council",
    github: "https://github.com/ayushjaswal",
    linkedin: "https://www.linkedin.com/in/ayushjaswal",
    instagram: "https://instagram.com/ayujaswal?igshid=ZDdkNTZiNTM=",
    twitter: "https://twitter.com/ayujas",
  },


  {
    image:
      "https://user-images.githubusercontent.com/75252077/236657358-d761716b-349d-4f04-9197-bc87ea7d080d.jpg",
    name: "Tushar Rai",
    position: "Ex- Senior Council",
    team: "SC",
    github: "https://github.com/Tushar1619",
    linkedin: "https://www.linkedin.com/in/tushar-rai-b94a79214",
    instagram: "https://instagram.com/raitushar132?igshid=ZDdkNTZiNTM=",
    twitter: "",
  },
  {
    "name": "Bhawansh Baleja",
    "image": "https://res.cloudinary.com/df5hitkbj/image/upload/v1696348115/WhatsApp_Image_2023-10-03_at_21.18.13_3bd7fcc4_dgtpwq.jpg",
    position: "Ex-Technical Head",
    github: "https://github.com/Bfacter",
    "linkedin": "https://www.linkedin.com//mwlite//in//bhawansh-baleja-a05450146",
    "instagram": "https://www.instagram.com//bhawansh_"
  },

  {
    "name": "Anand Mohan",
    "image": "https://i.postimg.cc//NjgdVcvV//unnamed.jpg",
    position: "Ex-Technical Head",
    "github": "https://github.com//Anand18m",
    "linkedin": "https://www.linkedin.com//in//anand-mohan-50324118b//",
    "instagram": "https://www.instagram.com//anand18mohan",
    "twitter": "https://twitter.com//Anand18m"
  },
  {
    name: "Aanya Sharma",
    image: "https://i.postimg.cc/hGsHhd6T/IMG-20221027-120758.jpg",
    position: "Ex-Junior Council",
    github: "https://github.com/Aanyaa26",
    linkedin: "https://www.linkedin.com/in/aanya-sharma-2841b2248",
    instagram: "https://www.instagram.com/aannyaasharma",
  },
  {
    name: "Chandan Sahoo",
    image: "https://res.cloudinary.com/dyfhx6mqp/image/upload/v1720981033/Chandan_Sahoo_xmu3pb.png",
    position: "EX-Junior Council",
    github: "https://github.com/chandanSahoo-cs",
    linkedin: "https://www.linkedin.com/in/chandansahoo-cs/",
    instagram: "https://www.instagram.com/chandan_sahoo001/",
  },
  {
    name: "Gauransh Goel",
    image: "https://i.postimg.cc/ZRrzvH3s/Gauransh-pic.png",
    position: "Ex-Junior Council",
    github: "https://github.com/Gauranshgoel123",
    linkedin: "https://www.linkedin.com/in/gauranshgoel123/",
    instagram: "https://www.instagram.com/gauranshhh_",
  },

  {
    name: "Niharika Khanna",
    image:
      "https://res.cloudinary.com/df5hitkbj/image/upload/v1699865733/NiharikaKhanna_pzwkmx.jpg",
    position: "Ex-Junior Council",
    github: "https://github.com/nkhanna94",
    linkedin: "https://www.linkedin.com/in/niharika-khanna-197236248/",
    instagram: "",
    twitter: "https://www.twitter.com/nkhanna94"
  },

  {
    name: "Navya Fulfagar",
    image: "https://i.postimg.cc/sfMHp8bM/IMG-9850.jpg",
    position: "Ex-Junior Council",
    linkedin: "https://www.linkedin.com/in/navya-jain-559198259",
    instagram: "https://www.instagram.com/navyaajainnn",
  },


  {
    name: "Himanshi Hans",
    image:
      "https://res.cloudinary.com/df5hitkbj/image/upload/v1699865734/Himanshi_Hans_1_p8xxtj.jpg",
    position: "Ex-Junior Council",
    github: "https://github.com/Himanshihans/",
    linkedin: "https://www.linkedin.com/in/himanshi-hans-23b895234",
    instagram: "",
  },


  {
    image:
      "https://github-production-user-asset-6210df.s3.amazonaws.com/50446690/241371327-1a87696e-c729-441b-a3ef-1059f63b56c2.jpg",
    name: "Surbhi Sinha",
    position: "Ex- Senior Council",
    team: "SC",
    github:
      "https://github.com/Surbhi-sinha?tab=overview&from=2022-12-01&to=2022-12-31",
    linkedin: "https://www.linkedin.com/in/surbhi-sinha-554902176/",
    instagram: "https://www.instagram.com/surbhisinha23/",
    twitter: "",
  },

  {
    image:
      "https://user-images.githubusercontent.com/75252077/236657397-ba7cb27a-62f8-48c9-bd1c-d6e048350aa5.jpg",
    name: "Dhruv Chandhok",
    position: "Ex- Senior Council",
    team: "SC",
    github: "https://github.com/Dhruv682",
    linkedin: "https://www.linkedin.com/in/dhruv-chandhok-b8a0841b5",
    instagram: "dhruv.chandhok",
    twitter: "",
  },
  {
    image: "https://i.postimg.cc/50g3J5HQ/me.jpg",
    name: "Manan Khandelwal",
    position: "Ex- Senior Council",
    team: "SC",
    github: "https://github.com/mnnkhndlwl",
    linkedin: "https://www.linkedin.com/in/mnnkhndlwl",
    instagram: "https://www.instagram.com/dev4.07/",
    twitter: "",
  },

  {
    image:
      "https://user-images.githubusercontent.com/75252077/236657078-11b60175-3b36-4809-ac07-d46dd55e267a.jpg",
    name: "Kirti Singh",
    position: "Ex- Senior Council",
    team: "SC",
    github: "",
    linkedin: "https://www.linkedin.com/in/kirti-singh-3b5b4b209/",
    instagram: "https://www.instagram.com/artsiek/",
    twitter: "",
  },

  {
    image:
      "https://user-images.githubusercontent.com/75252077/236657311-33327d52-57e2-4ca4-ad1d-8471a27f5d52.png",
    name: "Ishaan Sharma",
    position: "Ex- Senior Council",
    team: "SC",
    github: "",
    linkedin: "https://www.linkedin.com/in/ishaan09/",
    instagram: "https://www.instagram.com/_ishaanxsharma/",
    twitter: "",
  },

  {
    image:
      "https://user-images.githubusercontent.com/75252077/236658954-0ace632b-cdb7-470d-a50c-d474f1ab32ce.jpg",
    name: "Rishi Jha",
    position: "Ex- Junior Council",
    team: "JC",
    github: "https://github.com/rishi2025",
    linkedin: "https://www.linkedin.com/in/rishi--jha",
    instagram: "https://www.instagram.com/rishi_jha2520/",
    twitter: "",
  },

  {
    image:
      "https://user-images.githubusercontent.com/75252077/236659046-c3449307-bed6-4419-b28f-db75499506b6.jpg",
    name: "Smriti Grover",
    position: "Ex- Junior Council",
    team: "JC",
    github: "https://github.com/smritig26",
    linkedin: "https://www.linkedin.com/in/smriti-grover-016b8122a",
    instagram: "https://instagram.com/smriti.g26?igshid=ZDdkNTZiNTM=",
    twitter: "",
  },
  {
    image:
      "https://user-images.githubusercontent.com/75252077/236659070-1efe8a79-9b6d-4134-9bcc-af7eddc56f6d.jpg",
    name: "Smarth Malik",
    position: "Ex- Junior Council",
    team: "JC",
    github: "https://github.com/SMARTHMALIK",
    linkedin: "https://www.linkedin.com/in/smarth-malik-728bb6228",
    instagram: "https://instagram.com/smarthmalik2307?igshid=ZDdkNTZiNTM=",
    twitter: "https://twitter.com/MalikSmarth?t=WLSkszCe2-JPaa9pX8lajA&s=09",
  },

  {
    image:
      "https://user-images.githubusercontent.com/75252077/236659017-3bdddc9a-1494-4d65-b48d-1a0fa07596df.jpg",
    name: "Gracy Dhamija",
    position: "Ex- Junior Council",
    github: "https://github.com/gracy27",
    linkedIn: " https://www.linkedin.com/in/gracy-dhamija-4b2261239     ",
    instagram: "https://instagram.com/dhamijagracy?igshid=ZDdkNTZiNTM=",
    twitter: "https://twitter.com/dhamija_gracy?t=y0V-IH-0CrxhI-ZybbYc2w&s=09",
  },

  {
    image:
      "https://user-images.githubusercontent.com/75252077/236658826-fd7aec96-8585-4b60-bf6f-8affdbf04d84.jpg",
    name: "Pawas Goyal",
    position: "Ex- Junior Council",
    github: "https://github.com/pawas108ram",
    linkedin: "https://www.linkedin.com/in/pawas-goyal/",
    instagram: "https://www.instagram.com/pawas_licht03/",
    twitter: "",
  },

  {
    image:
      "https://user-images.githubusercontent.com/75252077/236659081-d0dff70f-522d-4bad-bb67-2ab050ec8802.jpg",
    name: "Vaibhav Bhardwaj",
    position: "Ex- Junior Council",
    github: "https://github.com/vaibhavx42",
    linkedIn: "https://www.linkedin.com/in/bhardwajvaibhav42/",
    instagram: "null",
    twitter: "https://twitter.com/__vxibhxv",
  },
];
